import { AfterViewInit, Component, ElementRef, Input } from '@angular/core';
import { Container } from '../container';

@Component({
  selector: 'slider-image',
  templateUrl: './slider.image.component.html',
  styleUrls: ['./slider.image.component.less']
})
export class SliderImageComponent extends Container implements AfterViewInit {

  private _sliderUl: HTMLElement;
  private _initialized = false;
  private _width = 0;
  private _imageArray = [];
  private _length = 0;
  private _itemIndex = 0;
  private _autoLoop = true;
  private _interval = 4000;
  private _intervalHandle;

  current = 0;
  idleArray = [];

  /**
   * slider创建完成后 是否自动开启循环播放
   * @param param
   */
  @Input()
  set autoLoop(param: boolean) {
    this._autoLoop = !!param;
    if (this._initialized) {
      this._hackAutoplay();
    }
  }

  /**
   * 图片切换的时间间隔
   * @param param
   */
  @Input()
  set interval(param: number) {
    if (param > 1000 && this._interval !== param) {
      this._interval = param;
      if (this._intervalHandle) {
        this.stop();
        this.start();
      }
    }
  }

  /**
   * 设置需要轮播的图片url数组
   * @param param
   */
  @Input()
  set imageArray(param: Array<string>) {
    this._imageArray = param;
    if (param && param.length > 0) {
      this.idleArray = new Array(this._length = param.length).fill('a');
      this._imageArray[this._length] = this._imageArray[0];
    }
  }

  get imageArray() {
    return this._imageArray;
  }

  constructor(private _elementRef: ElementRef) {
    super();
  }

  ngAfterViewInit() {
    const element: HTMLElement = this._elementRef.nativeElement;
    this._sliderUl = element.querySelector('.sliderUl');

    this._init();
  }

  private _init() {
    this._width = this._elementRef.nativeElement.offsetWidth;

    this._hackAutoplay();
    this._initialized = true;
  }

  /**
   * 容器大小发生变化   需要手工调用resize方法进行自适应调节
   */
  resize() {
    this._init();
  }


  pointerClick(index) {
    this.stop();
    this.goPage(index);
  }

  /**
   * 开始播放  不管autoLoop的标志是true or false
   */
  start() {
    if (!this._intervalHandle) {
      this._intervalHandle = setInterval(() => {
        // 更新current
        const preIndex = this.current;
        this.current = (preIndex + 1) % this._length;
        this._itemIndex = preIndex + 1;
        this._update();
      }, this._interval);
    }
  }

  stop() {
    if (this._intervalHandle) {
      clearInterval(this._intervalHandle);
      this._intervalHandle = 0;
    }
  }

  previous() {
    this.stop();
    const preIndex = this.current;
    this._itemIndex = this.current = preIndex === 0 ? this._length - 1 : preIndex - 1;
    this._update();
  }

  next() {
    this.stop();
    const preIndex = this.current;
    this.current = (preIndex + 1) % this._length;
    this._itemIndex = preIndex + 1;
    this._update();
  }

  /**
   * 跳转到index索引处的图片，index从0开始计数
   * @param index
   */
  goPage(index) {
    this.current = this._itemIndex = index % this._length;
    this._sliderUl.style.transform = `translateX(${-index * this._width}px)`;
    this._sliderUl.style.transitionDuration = '0.4s';
    this._sliderUl.style.transitionTimingFunction = 'ease-in';
    this._sliderUl.style.transitionProperty = 'transform';
  }

  private _hackAutoplay() {
    if (this._autoLoop) {
      this.start();
    }
  }

  private _update() {
    const sliderUl = this._sliderUl;

    sliderUl.style.transform = `translateX(${-this._itemIndex * this._width}px)`;
    sliderUl.style.transitionDuration = '0.4s';
    sliderUl.style.transitionTimingFunction = 'ease-in';
    sliderUl.style.transitionProperty = 'transform';

    if (this._itemIndex === this._length) {
      setTimeout(() => {
        sliderUl.style.transform = 'translateX(0px)';
        sliderUl.style.transitionDuration = 'none';
        sliderUl.style.transitionTimingFunction = 'none';
        sliderUl.style.transitionProperty = 'none';
        // 时间必须大于动画所需时间
      }, 500);
      this._itemIndex = 0;
    }
  }
}

